import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Spinner,
} from "reactstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Header from "components/Headers/Header";
import Cookies from "universal-cookie";
import ReactModal from "react-modal";
import Swal from "sweetalert2";
import ObtenerPropuesta from "./ObtenerPropuesta";

const CargaAnexo = ({ id }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [archivo, setArchivo] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const cookie = new Cookies();

  const abrirModal = () => setModalIsOpen(true);
  const cerrarModal = () => setModalIsOpen(false);

  const zIndexFix = () => {
    setTimeout(() => {
      const container = document.querySelector(".swal2-container");
      const popup = document.querySelector(".swal2-popup");
      if (container) container.style.zIndex = "9999";
      if (popup) popup.style.zIndex = "10000";
    }, 50);
  };

  const manejarCambioArchivo = (e) => setArchivo(e.target.files[0]);

  const subirArchivo = async () => {
    if (!archivo) {
      Swal.fire({
        icon: "warning",
        title: "Archivo requerido",
        text: "Por favor selecciona un archivo antes de continuar.",
        willOpen: zIndexFix,
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", archivo);
    setLoading(true);

    try {
      const response = await axios.post(
        `https://contratosback.azurewebsites.net/api/v1/CargaDocumentos/${id}/1/DocumentosAnexo/${cookie.get(
          "id",
        )}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      console.log("Respuesta del servidor:", response.data);

      await Swal.fire({
        icon: "success",
        title: "Carga exitosa",
        text: "El archivo se ha cargado correctamente.",
        timer: 2500,
        showConfirmButton: false,
        willOpen: zIndexFix,
      });

      window.location.reload("/");
    } catch (error) {
      console.error("Error al subir el archivo:", error);
      Swal.fire({
        icon: "error",
        title: "Error al subir",
        text: error.message || "Ocurrió un error al cargar el archivo.",
        willOpen: zIndexFix,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className="btn btn-primary btn-lg"
        onClick={abrirModal}
        style={{ padding: "5px", fontSize: "10px" }}
      >
        Anexos Adicionales
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={cerrarModal}
        contentLabel="Anexar Documento"
        style={{ overlay: { zIndex: 2000 } }}
      >
        <button
          onClick={cerrarModal}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "#a4a5a5",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "70px",
            height: "70px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 3000,
          }}
        >
          Cerrar
        </button>
        <Header />
        <Container className="mt--7" fluid>
          <Row>
            <Col>
              <Card className="shadow">
                <CardHeader className="border-0">
                  <h4 className="text-center">Cargar Documento Anexo</h4>
                  <hr />
                </CardHeader>
                <CardBody>
                  <input
                    type="file"
                    onChange={manejarCambioArchivo}
                    className="form-control mb-3"
                  />
                  <Button
                    color="primary"
                    block
                    onClick={subirArchivo}
                    disabled={isLoading}
                  >
                    {isLoading ? <Spinner size="sm" /> : "Guardar"}
                  </Button>
                  <br></br>
                  <br></br>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <br></br>
        <ObtenerPropuesta id={id} />
        <hr />
      </ReactModal>
    </>
  );
};

export default CargaAnexo;
